<template>
  <div class="gift-threshold-list">
    <template v-if="loading">
      Marathon gifts are loading...
    </template>
    <template
      v-else-if="marathonThresholdGifts && marathonThresholdGifts.length > 0"
    >
      <template
        v-for="(gift, index) in marathonThresholdGifts"
      >
        <GiftMenuCard
          :key="gift.giftCertificate.giftCertificateId"
          :benefit="gift"
          :index="index"
        >
          <template #after-progress="{ result }">
            <div
              v-if="result.additionalData && result.additionalData.orders && result.additionalData.orders.length > 0"
              class="d-flex flex-wrap align-center mt-1"
            >
              <span class="mr-2 mb-1">{{ $t("giftCardWidget.orders") }}</span>
              <v-chip
                v-for="order in result.additionalData.orders"
                :key="order.orderId"
                color="grey lighten-2"
                small
                class="mr-1 mb-1"
              >
                #{{ order.orderId }}
              </v-chip>
            </div>
          </template>
        </GiftMenuCard>
      </template>
    </template>
    <div v-else-if="!loading" class="empty-gifts">
      {{ $t("profile.gifts.emptyGifts") }}
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import customService from "@/service/customService";
import GiftMenuCard from "@/components/gift/GiftMenuCard.vue";

export default {
  name: "GiftThresholdList",
  components: { GiftMenuCard },
  data() {
    return {
      loading: true,
      marathonThresholdGifts: []
    };
  },
  computed: {
    ...mapState({
      category: ({ category }) => category.category
    })
  },
  methods: {
    async reload() {
      try {
        this.loading = true;
        const customBenefitsCode = this.$ebsn.meta(
          this.category,
          "category_advanced.CUSTOM_BENEFITS_CODE"
        );
        const result = await customService.getCustomBenefits(
          customBenefitsCode
        );
        console.log("marathonThresholdGifts", result);
        if (result && result.giftCertificateThresholds) {
          this.marathonThresholdGifts = result.giftCertificateThresholds;
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.loading = false;
      }
    }
  },
  mounted() {
    this.reload();
  }
};
</script>
